// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/blog_._index/BlogCard.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/blog_._index/BlogCard.tsx");
  import.meta.hot.lastModified = "1716289823161.2327";
}
// REMIX HMR END

import { format } from "date-fns";
export const BlogCard = ({
  title,
  description,
  created
}) => {
  return <article>
      <header className={"mb-1"}>
        <h2 className="text-3xl font-semibold">{title}</h2>
        <span className="text-gray-600">{format(created, "do LLL, yyyy")}</span>
      </header>
      <p>{description}</p>
    </article>;
};
_c = BlogCard;
var _c;
$RefreshReg$(_c, "BlogCard");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;